/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

import { get } from 'lodash';

export const manageExceptions = (payload, self) => {
  const status = get(payload, 'response.status', false);
  const description = get(payload, 'response.data.description', false);
  const route = get(payload, 'route', false);
  switch (status) {
    case 401:
      // eslint-disable-next-line no-case-declarations
      const cookieExp = description === 'Unauthorized: invalid or missing token';
      if (cookieExp) {
        self.$log.error('Unauthorized: invalid or missing token');
        self.$router.push('/logout');
      }
      break;
    case 403:
      // debugger;
      // eslint-disable-next-line no-case-declarations
      const registeredRequired = description === 'Registered user required';
      if (registeredRequired) {
        const redirectObj = {
          router: self.$router,
          registered: true,
          ls: self.$ls,
        };
        if (route) {
          redirectObj.route = route;
        }
        self.redirectToIP(redirectObj);
      }
      break;
    case 404:
      self.$log.error('404');
      break;
    case 451:
      self.$store.commit('appReady', true);
      self.$router.push('/unavailable');
      break;
    default:
  }
};

const manageNegramaroException = (payload, self) => {
  const status = get(payload, 'response.status', false);
  const description = get(payload, 'response.data.description', false);
  const route = get(payload, 'route', false);
  switch (status) {
    case 401:
      // eslint-disable-next-line no-case-declarations
      const cookieExp = description === 'Unauthorized: invalid or missing token';
      if (cookieExp) {
        self.$log.error('Unauthorized: invalid or missing token');
        self.$router.push('/logout');
      }
      break;
    case 402:
      self.$log.error('Unauthorized: no valid offer');
      // eslint-disable-next-line no-case-declarations
      const noOffer = description === 'No Negramaro offer found for current user';
      if (noOffer) {
        self.$router.push('/ticket');
      }
      break;
    case 403:
      // debugger;
      // eslint-disable-next-line no-case-declarations
      const registeredRequired = description === 'Registered user required';
      if (registeredRequired) {
        const redirectObj = {
          router: self.$router,
          registered: true,
          ls: self.$ls,
        };
        if (route) {
          redirectObj.route = route;
          redirectObj.returnURI = `${this.conf[this.env].baseUrl}login2`;
        }

        self.redirectToIP(redirectObj);
      }
      break;
    case 404:
      self.$log.error('404');
      break;
    case 451:
      self.$store.commit('appReady', true);
      self.$router.push('/unavailable');
      break;
    default:
  }
};
export default manageNegramaroException;
